jQuery(document).ready(function ($) {

	function getScrollOffset() {
		let offset = 115;
		const $rowLinks = $('.row-links-menu');

		if ($rowLinks.length && $rowLinks.css('position') === 'sticky' || $rowLinks.css('position') === 'fixed') {
			const rowLinksHeight = $rowLinks.outerHeight(true); // includes margins
			const paddingTop = parseFloat($rowLinks.css('padding-top')) || 0;

			offset += (rowLinksHeight - paddingTop);
		}



		return offset;
	}

	function initSmoothScroll() {
		$('a[href*="#"]:not([href="#"])').on('click', function(e) {
			const pathnameMatch = location.pathname.replace(/^\//, '') === this.pathname.replace(/^\//, '');
			const hostnameMatch = location.hostname === this.hostname;

			if (pathnameMatch && hostnameMatch) {
				const target = $(this.hash).length ? $(this.hash) : $(`[name="${this.hash.slice(1)}"]`);

				if (target.length) {
					e.preventDefault();

					$('html, body').animate({
						scrollTop: target.offset().top - getScrollOffset()
					}, 700);
				}
			}
		});
	}

	initSmoothScroll();

});